import { OpportunityAgreementStatus } from "@freightsimple/generated-carriers-openapi-client/models/OpportunityAgreementStatus";

// Where the carrier stands on an opportunity, as a dot colour. Grey for freight
// nobody has claimed yet (it's an invitation, not a problem), gold while we're
// waiting on the carrier, blue while we set it up, green once it's live.
type OpportunityDotColor =
  | "grey"
  | "gold"
  | "blue"
  | "green"
  | "red"
  | "purple";

const STATUS_DOT_COLORS: Record<
  OpportunityAgreementStatus,
  OpportunityDotColor
> = {
  [OpportunityAgreementStatus.None]: "grey",
  [OpportunityAgreementStatus.Interested]: "blue",
  [OpportunityAgreementStatus.AwaitingPricing]: "gold",
  [OpportunityAgreementStatus.BeingSetUp]: "blue",
  [OpportunityAgreementStatus.Active]: "green",
  [OpportunityAgreementStatus.Declined]: "red",
  [OpportunityAgreementStatus.Cancelled]: "grey",
  [OpportunityAgreementStatus.ExistingCustomer]: "purple",
};

export function opportunityStatusDotColor(
  status: OpportunityAgreementStatus,
): OpportunityDotColor {
  return STATUS_DOT_COLORS[status] ?? "grey";
}

/**
 * Coverage is the number that settles most declines before anyone writes an
 * email, so it's worth saying plainly whether it's worth their time.
 */
export function describeCoverage(percentage: number | undefined): string {
  if (percentage === undefined) return "Not evaluated";
  return `${Math.round(percentage * 100)}% in your service area`;
}
